const Role = {
  PortalAdmin: "portal-admin",
  Purchaser: "purchaser",
  FleetManager: "fleet-manager",
  DataAnalyst: "data-analyst",
};

export { Role };